module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@1.2.7@core-js/library/modules/$.html.js
// module id = 396
// module chunks = 0